// @flow
// This limits the size of underscore.string to just the functions we use.

export default {
  trim: require('underscore.string/trim'),
  include: require('underscore.string/include'),
  humanize: require('underscore.string/humanize'),
  contains: require('underscore.string/include'),
  words: require('underscore.string/words'),
  endsWith: require('underscore.string/endsWith'),
  startsWith: require('underscore.string/startsWith'),
  ltrim: require('underscore.string/ltrim'),
  slugify: require('underscore.string/slugify'),
  truncate: require('underscore.string/truncate'),
  reverse: require('underscore.string/reverse'),
  underscored: require('underscore.string/underscored'),
  capitalize: require('underscore.string/capitalize'),
  levenshtein: require('underscore.string/levenshtein'),
  toSentenceSerial: require('underscore.string/toSentenceSerial'),
  clean: require('underscore.string/clean'),
  titleize: require('underscore.string/titleize'),
  dasherize: require('underscore.string/dasherize'),
};
